package example.shadcn_kotlin.ui.pages.docs.components.context_menu

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.ContextMenuDemo

@Page
@Composable
fun IndexPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/context-menu/index.md", mapOf("title" to listOf("Context Menu"), "description" to listOf("Displays a menu to the user — such as a set of actions or functions — triggered by a button."), "radix" to listOf()))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.*
import web.cssom.ClassName

val ContextMenuDemo = FC<Props> {
    ContextMenu {
        ContextMenuTrigger {
            className = ClassName("flex h-[150px] w-[300px] items-center justify-center rounded-md border border-dashed text-sm")
            +"Right click here"
        }
        ContextMenuContent {
            className = ClassName("w-64")
            ContextMenuItem {
                inset = true
                +"Back"
                ContextMenuShortcut { +"⌘[" }
            }
            ContextMenuItem {
                inset = true
                disabled = true
                +"Forward"
                ContextMenuShortcut { +"⌘]" }
            }
            ContextMenuItem {
                inset = true
                +"Reload"
                ContextMenuShortcut { +"⌘R" }
            }
            ContextMenuSub {
                ContextMenuSubTrigger {
                    inset = true
                    +"More Tools"
                }
                ContextMenuSubContent {
                    className = ClassName("w-48")
                    ContextMenuItem {
                        +"Save Page As..."
                        ContextMenuShortcut { +"⇧⌘S" }
                    }
                    ContextMenuItem { +"Name Window" }
                    ContextMenuSeparator {}
                    ContextMenuItem { +"Developer Tools" }
                }
            }
            ContextMenuSeparator {}
            ContextMenuCheckboxItem {
                checked = true
                +"Show Bookmarks Bar"
                ContextMenuShortcut { +"⌘⇧B" }
            }
            ContextMenuCheckboxItem {
                +"Show Full URLs"
            }
            ContextMenuSeparator {}
            ContextMenuRadioGroup {
                value = "pedro"
                ContextMenuLabel {
                    inset = true
                    +"People"
                }
                ContextMenuSeparator {}
                ContextMenuRadioItem {
                    value = "pedro"
                    +"Pedro Duarte"
                }
                ContextMenuRadioItem {
                    value = "colm"
                    +"Colm Tuite"
                }
            }
        }
    }
}"""){ 
 ContextMenuDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.ContextMenu
import shadcn.ui.components.ContextMenuContent
import shadcn.ui.components.ContextMenuItem
import shadcn.ui.components.ContextMenuTrigger
""", lang= "kotlin", highlight= "")
            CodeBlock("""ContextMenu {
    ContextMenuTrigger { + "Right click" }
    ContextMenuContent {
        ContextMenuItem { + "Profile" }
        ContextMenuItem { + "Billing" }
        ContextMenuItem { + "Team" }
        ContextMenuItem { + "Subscription" }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
